import { useQuery } from '@tanstack/react-query';
import { getSuppliers } from '../services/supplierService';
import { queryKeys } from '../constants/queryKeys';

const PAGE_SIZE = 20;

// Fetch paginated supplier list — returns the raw envelope { data, totalPages, ... }
export const useSuppliers = (page = 1, search = '') => {
  return useQuery({
    queryKey: queryKeys.suppliers.list(page, search),
    queryFn: () => getSuppliers({ page, pageSize: PAGE_SIZE, search: search || undefined }),
  });
};
